import { lazy } from 'react';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() => lazyRetry(() => import(/* webpackChunkName: "paymentMessage" */ './PaymentMessage')));

const LazyComponentWithSuspense = withSuspense<{}>(LazyComponent, 'PaymentMessage', '');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as PaymentMessage };
